// router/routes.ts
import type { RouteRecordRaw } from 'vue-router'

// const userStore = useUserStore()
const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: '/404',
    meta: {
      title: '404',
      canAccess: () => true
    },
    component: () => import('@/views/system/error/404.vue')
  },
  {
    path: '/401',
    meta: {
      title: '401',
      canAccess: () => true
    },
    component: () => import('@/views/system/error/401.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      canAccess: () => true
    },
    component: () => import('@/views/system/loginView.vue')
  },
  // {
  //   path: '/companyRegister',
  //   name: 'companyRegister',
  // component: () => import('@/views/system/CompanyRegisterView.vue')
  // },
  {
    path: '/register',
    redirect: '/login'
  },
  {
    path: '',
    redirect: '/index',
    component: () => import('@/components/layout/system/IndexLayout.vue'),
    children: [
      {
        path: '/index',
        // redirect: () => (useUserStore().defaultIdentity == 0 ? '/serviceList' : '/companyInfo'), // /dashboard/index
        meta: {
          title: '首页'
        },
        component: () => import('@/views/system/indexView.vue')
        // component: () => import('@/views/company/companyInfo/companyInfoView.vue')
      },
      {
        path: '/serviceCateEchartsLine',
        meta: {
          title: '服务分类月度量'
        },
        component: () => import('@/views/company/workOrder/statistics/serviceCateEchartsLine.vue')
      },
      {
        path: '/serviceCatePieEcharts',
        meta: {
          title: '服务分类总量饼图'
        },
        component: () => import('@/views/company/workOrder/statistics/serviceCatePieEcharts.vue')
      },
      {
        path: '/serviceWayPieEcharts',
        meta: {
          title: '服务方式总量饼图'
        },
        component: () => import('@/views/company/workOrder/statistics/serviceWayPieEcharts.vue')
      },
      {
        path: '/serviceTotalPieEcharts',
        meta: {
          title: '服务总量饼图'
        },
        component: () => import('@/views/company/workOrder/statistics/serviceTotalPieEcharts.vue')
      },
      {
        path: '/serviceEnrollRatioPieEcharts',
        meta: {
          title: '服务登记饼图'
        },
        component: () => import('@/views/company/workOrder/statistics/serviceEnrollRatioPieEcharts.vue')
      },
      {
        path: '/serviceDispatchPieEcharts',
        meta: {
          title: '服务派单饼图'
        },
        component: () => import('@/views/company/workOrder/statistics/serviceDispatchPieEcharts.vue')
      },
      {
        path: '/serviceFinishPieEcharts',
        meta: {
          title: '服务完成饼图'
        },
        component: () => import('@/views/company/workOrder/statistics/serviceFinishPieEcharts.vue')
      },
      {
        path: '/serviceFinishByPersonPie',
        meta: {
          title: '个人完成饼图'
        },
        component: () => import('@/views/company/workOrder/statistics/serviceFinishByPersonPieEcharts.vue')
      },
      {
        path: '/knowledgeBase',
        meta: {
          title: '组织知识库'
        },
        component: () => import('@/views/company/knowledgeBase/knowledgeBaseListView.vue')
      },
      {
        path: '/knowledgeBase/qa',
        meta: {
          title: '知识库问答'
        },
        component: () => import('@/views/company/knowledgeBase/knowledgeBaseQaView.vue')
      },
      {
        path: '/service/cate',
        meta: {
          title: '服务分类'
        },
        component: () => import('@/views/company/workOrder/cate/serviceCate.vue')
      },
      {
        path: '/work/userList',
        meta: {
          title: '员工管理'
        },
        component: () => import('@/views/company/companyUser/companyUserListView.vue')
      },
      {
        path: '/serviceList',
        name: 'serviceList',
        meta: {
          title: '服务清单'
        },
        component: () => import('@/views/company/workOrder/workOrderList/serviceListView.vue')
      },
      // {
      //   path: '/customersWorkOrderView',
      //   name: 'customersWorkOrderView',
      //   meta: {
      //     title: '乙方单位获取对企业客户提供的服务'
      //   },
      //   component: () => import('@/views/company/customers/customersWorkOrderView.vue')
      // },
      // {
      //   path: '/FinishService',
      //   meta: {
      //     title: '新建服务'
      //   },
      //   component: () => import('@/views/company/workOrder/workOrderAction/FinishService.vue')
      // },
      {
        path: '/companyInfo',
        meta: {
          title: '企业信息'
        },
        component: () => import('@/views/company/companyInfo/companyInfoView.vue')
      },
      // {
      //   path: '/companyFollowCompany',
      //   name: 'companyFollowCompany',
      //   meta: {
      //     title: '企业关注客户'
      //   },
      //   component: () => import('@/views/company/companyfollow/companyFollowCompanyView.vue')
      // },
      {
        path: '/companyDept',
        meta: {
          title: '部门管理'
        },
        component: () => import('@/views/company/companyInfo/companyDeptView.vue')
      },
      {
        path: '/companyPost',
        meta: {
          title: '部门管理'
        },
        component: () => import('@/views/company/companyInfo/companyPostView.vue')
      },
      {
        path: '/settings/companyDelete',
        meta: {
          title: '注销组织'
        },
        component: () => import('@/views/company/settings/companyDeleteView.vue')
      },
      {
        path: '/work/customersUserList',
        meta: {
          title: '联系人管理'
        },
        component: () => import('@/views/company/customers/customersUserListView.vue')
      },
      {
        path: '/work/customers',
        meta: {
          title: '企业客户'
        },
        component: () => import('@/views/company/customers/customersView.vue')
      },
      {
        path: '/serviceProvider',
        meta: {
          title: '服务商'
        },
        component: () => import('@/views/company/provider/companyServiceProvider.vue')
      },
      {
        path: '/work/expenseInvoiceList',
        meta: {
          title: '费用单据'
        },
        component: () => import('@/views/company/expense/expenseInvoiceListView.vue')
      }
      // {
      //   path: '/myexpenses',
      //   meta: {
      //     title: '我的费用'
      //   },
      //   component: () => import('@/views/company/finance/myExpensesView.vue')
      // },
      // {
      //   path: '/myexpensesapprove',
      //   meta: {
      //     title: '我的费用'
      //   },
      //   component: () => import('@/views/company/finance/myExpensesApproveView.vue')
      // },
      // {
      //   path: '/expensesPayment',
      //   meta: {
      //     title: '费用支付'
      //   },
      //   component: () => import('@/views/company/finance/expensesPaymentView.vue')
      // },
    ]
  },
  {
    path: '/device',
    component: () => import('@/components/layout/system/IndexLayout.vue'),
    children: [
      {
        path: '/device/list',
        meta: {
          title: '设备清单'
        },
        component: () => import('@/views/company/device/listView.vue')
      },
      {
        path: '/device/pickupInfo',
        meta: {
          title: '采集信息'
        },
        component: () => import('@/views/company/device/pickupInfo.vue')
      },
      {
        path: '/device/pickupInfo/typeDetail',
        meta: {
          title: '采集项类型详情'
        },
        component: () => import('@/views/company/device/pickupInfo/typeDetail.vue')
      }
    ]
  },
  {
    path: '/assets',
    component: () => import('@/components/layout/system/IndexLayout.vue'),
    children: [
      {
        path: '/assets/list',
        meta: {
          title: '资产清单'
        },
        component: () => import('@/views/company/assets/list.vue')
      }
    ]
  },
  {
    path: '/service',
    component: () => import('@/components/layout/system/IndexLayout.vue'),
    children: [
      {
        path: '/service/amountOfCustomerService',
        meta: {
          title: '客户-服务量'
        },
        component: () => import('@/views/company/workOrder/amountOfCustomerService.vue')
      },
      {
        path: '/service/amountOfProviderService',
        meta: {
          title: '服务商-服务量'
        },
        component: () => import('@/views/company/workOrder/amountOfProviderService.vue')
      }
    ]
  },
  {
    path: '/serviceStatistics',
    component: () => import('@/components/layout/system/IndexLayout.vue'),
    children: [
      {
        path: '/serviceStatistics/staffWorkload',
        meta: {
          title: '职工工作量统计'
        },
        component: () => import('@/views/company/workOrder/statistics/staffWorkload.vue')
      },
      {
        path: '/serviceStatistics/staffWorkEfficiency',
        meta: {
          title: '职工工作效率'
        },
        component: () => import('@/views/company/workOrder/statistics/staffWorkEfficiency.vue')
      }
    ]
  },
  {
    path: '/ui',
    component: () => import('@/components/layout/system/IndexLayout.vue'),
    children: [
      {
        path: '/ui/demo/icon',
        meta: {
          title: '自定义图标'
        },
        component: () => import('@/views/demo/icon/CustomListView.vue')
      },
      {
        path: '/ui/demo/echarts',
        meta: {
          title: 'echarts-demo'
        },
        component: () => import('@/views/demo/echarts.vue')
      }
    ]
  },
  {
    path: '/HelloWorld',
    name: 'HelloWorld',
    meta: {
      title: '测试页面',
      canAccess: () => import.meta.env.DEV
    },
    component: () => import('@/views/demo/HelloWorld.vue')
  }
]

export default routes
